import { getFontSize } from '../../../../../../constants/fontSizes';

export const datePickerStyles = {
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    flex: 1,
  },
  inputContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    padding: '5px 15px',
    backgroundColor: '#fff',
    borderRadius: '90px',
    border: '1px solid #D4D4D4',
    cursor: 'pointer',
    position: 'relative',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  title: {
    fontSize: getFontSize(14),
    fontWeight: 500,
    color: '#252629',
    fontFamily: 'Lato',
    textAlign: 'left',
  },
  subtitle: {
    fontSize: getFontSize(18),
    color: '#252629',
    fontFamily: 'Lato',
    textAlign: 'left',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#252629',
    zIndex: 2
  },
  hiddenInput: {
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    cursor: 'pointer',
    zIndex: 1,
    '& .MuiInputBase-root': {
      width: '100%',
      height: '100%',
    },
    '& .MuiInputBase-input': {
      cursor: 'pointer',
      height: '100%',
      padding: 0,
    },
  },
  datePickerPopper: {
    zIndex: 10,
    '& .MuiPaper-root': {
      backgroundColor: '#fff',
      color: '#252629',
      borderRadius: '14px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    },
    '& .MuiPickersCalendarHeader-root': {
      color: '#252629',
    },
    '& .MuiPickersCalendarHeader-label': {
      color: '#252629',
      fontFamily: 'Lato',
    },
    '& .MuiPickersCalendarHeader-labelContainer': {
      '& .MuiPickersCalendarHeader-label': {
        color: '#252629',
      },
    },
    '& .MuiIconButton-root': {
      color: '#252629',
      '&:hover': {
        backgroundColor: 'rgba(37, 38, 41, 0.1)',
      },
    },
    '& .MuiDayCalendar-weekDayLabel': {
      color: '#252629',
      fontFamily: 'Lato',
      fontWeight: 500,
    },
    '& .MuiDayCalendar-weekContainer': {
      '& .MuiPickersDay-root': {
        color: '#252629',
        fontFamily: 'Lato',
        '&:hover': {
          backgroundColor: 'rgba(37, 38, 41, 0.1)',
        },
        '&.Mui-selected': {
          backgroundColor: '#00443F',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#00443F',
          },
          '&:focus': {
            backgroundColor: '#00443F',
          },
        },
        '&.MuiPickersDay-today': {
          border: '1px solid #252629',
          fontWeight: 500,
          '&.Mui-selected': {
            border: '1px solid #fff',
          },
        },
      },
    },
    '& .MuiPickersCalendarHeader-switchViewButton': {
      color: '#252629',
    },
  },
};

